import React, { useState, useEffect } from 'react';

const BotonOpcion = (p) => {
    const name = p.name ?? 'No se asignó nombre';
    const keyName = p.keyName ?? '';
    const isSelected = p.isSelected ?? false;

    useEffect(() => {

    }, []);

    return (


        <div className='bw m-0 mt-2 mb-2' style={{ width: `${Math.ceil(name.length * 7.5)}px` }}>
            <button className={`w-100 btn btn-sm round-xxl btn-${isSelected ? 'warning text-bold' : 'light shadow border border-secondary'}`}
                name={keyName} onClick={(event) => { if (p.funcion) p.funcion(event) }} >{name}</button>
        </div>


    )
}

export default BotonOpcion;